export default __webpack_public_path__ + "static/media/Majenta_Oil_Painting.cb87c3e9.jpg";